__turbopack_context__.v({
  "default": "link-module-scss-module__lrZi5a__default",
  "disabled": "link-module-scss-module__lrZi5a__disabled",
  "link": "link-module-scss-module__lrZi5a__link",
  "primary": "link-module-scss-module__lrZi5a__primary",
  "secondary": "link-module-scss-module__lrZi5a__secondary",
  "start-icon": "link-module-scss-module__lrZi5a__start-icon",
});
